var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFast = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.555 0.16815C1.4044 0.0676712 1.22935 0.00996145 1.04852 0.00117785C0.867687 -0.00760575 0.687865 0.032866 0.528235 0.118276C0.368605 0.203685 0.235156 0.330829 0.142126 0.486141C0.049095 0.641453 -2.70837e-05 0.819107 1.12028e-08 1.00015V9.00015C-2.70837e-05 9.18119 0.049095 9.35885 0.142126 9.51416C0.235156 9.66947 0.368605 9.79661 0.528235 9.88202C0.687865 9.96743 0.867687 10.0079 1.04852 9.99912C1.22935 9.99034 1.4044 9.93263 1.555 9.83215L7 6.20215V9.00015C6.99997 9.18119 7.04909 9.35885 7.14213 9.51416C7.23516 9.66947 7.3686 9.79661 7.52823 9.88202C7.68786 9.96743 7.86769 10.0079 8.04852 9.99912C8.22935 9.99034 8.4044 9.93263 8.555 9.83215L14.555 5.83215C14.692 5.74083 14.8043 5.61711 14.8819 5.47197C14.9596 5.32683 15.0002 5.16476 15.0002 5.00015C15.0002 4.83554 14.9596 4.67347 14.8819 4.52833C14.8043 4.38319 14.692 4.25947 14.555 4.16815L8.555 0.16815C8.4044 0.0676712 8.22935 0.00996145 8.04852 0.00117785C7.86769 -0.00760575 7.68786 0.032866 7.52823 0.118276C7.3686 0.203685 7.23516 0.330829 7.14213 0.486141C7.04909 0.641453 6.99997 0.819107 7 1.00015V3.79815L1.555 0.16815Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Fast.57e27cc49fa6781fce5bf0425329032a.svg";